import { Injectable } from '@angular/core';
import { NotifyUtils } from '@app/shared/utils/notify.utils';
import { Observable, firstValueFrom } from 'rxjs';
import { VisionStatementMessages } from '../locale/vison-statement.messages';
import { CreateVisionStatement } from '../model/create-vision-statement.model';
import { VisionStatement } from '../model/vision-statement.model';
import { VisionStatementAPIService } from './vision-statement-api.service';
import { InFlightRegistry } from '@app/shared/utils/in-flight-registry';

// Single-slot guard: the vision statement is a company singleton, so all writes share one key. A
// duplicate write while one is in flight is coalesced onto the same promise (see InFlightRegistry).
const WRITE_KEY = 'write';

@Injectable({
  providedIn: 'root'
})
export class VisionStatementBusinessService {

  private updating: InFlightRegistry;

  constructor(
    private visionAPI: VisionStatementAPIService,
    private notifyUtils: NotifyUtils
  ) {
    this.updating = new InFlightRegistry();
  }

  get(): Observable<VisionStatement> {
    return this.visionAPI.getVision();
  }

  set(visionStatement: CreateVisionStatement): Promise<VisionStatement> {
    return this.updating.run(WRITE_KEY, () =>
      firstValueFrom(this.visionAPI.setVision(visionStatement))
        .then(res => {
          this.notifyUtils.notify(VisionStatementMessages.SUCCESS_SET_VISION);
          return res;
        })
    );
  }

  delete(): Promise<VisionStatement> {
    return this.updating.run(WRITE_KEY, () =>
      firstValueFrom(this.visionAPI.deleteVision())
        .then(res => {
          this.notifyUtils.notify(VisionStatementMessages.SUCCESS_DELETE_VISION);
          return res;
        })
    );
  }
}
